// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable new-cap, babel/new-cap, func-names, default-param-last */
import { Record, Map, List } from "immutable"
import type { Dispatch } from "redux"
import { bookingDataSelector } from "@kiwicom/frontend-common/services/booking/booking"
import { getAirlines } from "@kiwicom/frontend-common/services/staticData"

import type {
  AlternativeFlightsStateType,
  AlternativeFlightsStateInst,
  Action,
  SearchId,
  Flights,
} from "./AlternativeFlightsDuck.types"
import * as bookingApi from "../../../../../../../services/bookings/bookingsApi"
import { searchIdWithFiltersSelector } from "../../../services/changeFlights/alternativeFlightsSelector"
import { urlQuerySelector } from "@kiwicom/frontend-common/services/query/selector"
import { isTequilaSelector } from "@kiwicom/frontend-common/services/options/selectors"

const FETCH = "alternativeFlights/FETCH"
const FETCH_REQUEST = "alternativeFlights/FETCH_REQUEST"
const FETCH_SUCCESS = "alternativeFlights/FETCH_SUCCESS"
const FETCH_FAILURE = "alternativeFlights/FETCH_FAILURE"
const CLEAR = "alternativeFlights/CLEAR"

const AlternativeFlightsState: AlternativeFlightsStateType = Record({
  flights: Map(),
  loading: Map(),
  error: null,
})

export default function (
  state: AlternativeFlightsStateInst | null | undefined = new AlternativeFlightsState(),
  action: Action,
) {
  if (!(state instanceof AlternativeFlightsState)) return new AlternativeFlightsState(state)

  switch (action.type) {
    case CLEAR:
      return new AlternativeFlightsState()

    case FETCH_REQUEST:
      return state.setIn(["loading", action.id], true).set("error", false)

    case FETCH_SUCCESS:
      return state
        .setIn(["flights", action.id], List(action.res))
        .setIn(["loading", action.id], false)
        .set("error", false)

    case FETCH_FAILURE:
      return state.setIn(["loading", action.id], false).set("error", action.error)

    default:
      return state
  }
}

export function findAlternativesAction(id: SearchId, promise: Promise<Flights>) {
  return {
    type: FETCH,
    id,
    promise,
  }
}

export function clearAlternatives() {
  return {
    type: CLEAR,
  }
}

// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const searchAlternatives = () => (dispatch: Dispatch<any>, getState: () => any) => {
  const state = getState()
  const booking = bookingDataSelector(state)
  const searchForm = state.plainSearchForm.form
  const airlines = getAirlines(state)
  const {
    selected,
    form: { fields },
  } = state.changeFlights

  // On tequila we have to send the partner param to the backend.
  // This allows them to apply the appropriate partner-related filters to
  // the alternatives that are returned.
  const isTequila = isTequilaSelector(state)
  const query = urlQuerySelector(state)
  const partner = isTequila ? query?.partner : undefined

  const promise = bookingApi.findAlternatives(
    booking,
    selected,
    searchForm,
    fields,
    airlines,
    partner,
  )
  const searchIdWithFilters = searchIdWithFiltersSelector(state)
  dispatch(findAlternativesAction(searchIdWithFilters, promise))
}
